import {apiRegister} from '../../common/api'
import {forEach} from '../../utils/base'
import {KUser} from '../../models/k-user'

export const commentPost = apiRegister('commentPost', {
  protoId: 74,
  path: '/comment/post/'
}).send

export const commentList = apiRegister('commentList', {
  protoId: 75,
  path: '/comment/list/',
  formatResult({total, list, userInfos}) {
    userInfos = userInfos || []
    const userMap = {}
    forEach(userInfos, user => {
      userMap[user.uid] = KUser(user)
    })
    return {
      total,
      list,
      userMap
    }
  }
}).send

/**
* 声明接口：/comment/zan/post/
* id:87
* 评论留言列表
*/
export const commentZanPost = ('commentZanPost', {
  path : '/comment/zan/post/',
  check : function(query, reson) {
      query.objType = 10 //评论对象类型
      return query
  },
  format : function(result, reson) {
      if(!reson.code) {
          //开始格式化数据结果
      }
      return result
  }
}).send

